module.exports = __webpack_public_path__ + "static/media/bar-brewery-winery-hero.e0a75264.jpg";